import { render } from "./PatientListSearchedOffcanvas.vue?vue&type=template&id=5780d034&scoped=true"
import script from "./PatientListSearchedOffcanvas.vue?vue&type=script&lang=js"
export * from "./PatientListSearchedOffcanvas.vue?vue&type=script&lang=js"

import "./PatientListSearchedOffcanvas.vue?vue&type=style&index=0&id=5780d034&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5780d034"]])

export default __exports__